import { useQuery, useMutation } from "@apollo/client";
import moment from "moment";
import Link from "next/link";
import { FC, useEffect } from "react";
import { GET_MEMBER_DONATIONS } from "../../queries/queries";
import { GetMemberDonationsQuery } from "../../types/generated/graphql";
import { Member, Payment } from "../../types/types";
import { fetchPostJSON } from "../../utils/api-helpers";
import { MenuBar } from "./MenuBar";

interface MypageProps {
  auth0_id: string;
}

export const History: FC<MypageProps> = ({ auth0_id }) => {
  useEffect(() => {
    fetchPostJSON("/api/stripe/fetch_payments").then((data) => {});
  }, []);

  const { data, error, loading } = useQuery<GetMemberDonationsQuery>(
    GET_MEMBER_DONATIONS,
    {
      fetchPolicy: "cache-and-network",
      variables: { auth0_id: auth0_id },
    }
  );
  return (
    <div className="mypage-page">
      <div className="p-pageTtl">
        <div className="p-pageTtl__inner">
          <div className="l-container">
            <h2 className="p-pageTtl__ttl">マイページ</h2>
          </div>
        </div>
      </div>

      <section className="mypage-form">
        <div className="mypage-form__inner">
          <div className="l-container">
            <MenuBar currentPage="history" />
          </div>

          <div className="l-container">
            <div className="p-format">
              {loading ? (
                <div className="flex justify-center">
                  <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full"></div>
                  <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full mx-8"></div>
                  <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full"></div>
                </div>
              ) : (
                <table className="-his">
                  <tr>
                    <th>寄付日</th>
                    <th>寄付額</th>
                    <th>寄付メニュー</th>
                  </tr>

                  {data &&
                    data!.members_by_pk!.donations.map((donation) => {
                      return (
                        <tr key={donation.id}>
                          <td className="-date">
                            {moment(
                              donation.stripe_transactioned_at ||
                                donation.created_at
                            ).format("YYYY/MM/DD")}
                          </td>
                          <td>
                            {donation.payment_method == "bank" &&
                            donation.amount == 0
                              ? "振込案内をお送りします。こちらで振込内容が確認出来次第、寄付金額を反映いたします。"
                              : `¥${donation.amount.toLocaleString()}`}
                          </td>
                          <td>
                            {donation.donation_type == "one_time"
                              ? "今回（１回）のみ寄付"
                              : "マンスリーサポーター（毎月・定額）"}
                          </td>
                        </tr>
                      );
                    })}
                </table>
              )}
            </div>

            {/* <div className="p-pageNav">
              <div className="p-pageNav__inner">
                <div className="p-pageNav__nums">
                  <ul>
                    <li className="is-cr">
                      <a href="">1</a>
                    </li>
                  </ul>
                </div>
                <div className="p-pageNav__btns">
                  <div className="p-pageNav__btn">
                    <p className="c-btn -wt -prev">
                      <a href="./mypage-page1.html" className="u-over">
                        戻る
                      </a>
                    </p>
                  </div>
                  <div className="p-pageNav__btn">
                    <p className="c-btn">
                      <a href="./mypage-page3.html" className="u-over">
                        次へ
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div> */}

            <p className="c-btn -noBg">
              <Link href="/mypage/resign">
                <a className="u-over">退会する</a>
              </Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
